import { http } from '@/core/api/';
const apiUrl = 'api/autismsurveillancenetwork';

export default {
  async getStudents(payload){
    return await http.get(
      `${apiUrl}/searchstudents`, {
        params: {
          ...payload
        }
      }
    );
  }
}